"use client";
import { mapModifiers } from "@/utils/funtion";
import Image from "next/image";
import mission from "@/assets/images/service/s.svg";
import prise from "@/assets/images/service/prise.jpg";
import vision from "@/assets/images/service/v.svg";
import { FiCheckCircle } from "react-icons/fi";

const AboutModule = () => {
    return (
        <div className={mapModifiers("p-about")}>
            <div className={mapModifiers("p-about_wrapper")}>
                <div className="page-title">
                    Giới thiệu  
                </div>
                <div className="p-about_line"></div>
                <div className="p-about_text">
                    <p>Biên giới phân tích dữ liệu đang ngày càng mở rộng nhanh chóng và đường chân trời là đầy hứa hẹn. Những tiến bộ công nghệ mà chúng ta đang chứng kiến mang tính cách mạng, vượt qua ranh giới của những gì có thể làm được trong kỹ thuật phân tích dữ liệu. Tuy nhiên, kỹ thuật phân tích dữ liệu có hiện đại thế nào cũng sẽ vô nghĩa hoặc giảm ý nghĩa nếu như không có dữ liệu tốt.</p>
                    <p>Dữ liệu đóng vai trò là nền tảng của công nghệ hiện đại, từ đồng hồ theo dõi sức khỏe đến các chính phủ thông minh, từ cá nhân, tổ chức, doanh nghiệp đến các nhà hoạch định chính sách. Clive Robert Humby xem dữ liệu như là dầu mỏ mới của thế kỷ 21, còn chúng tôi xem dữ liệu là nhựa sống trong kỷ nguyên số. Nói chung, dữ liệu đóng vai trò to lớn trong xã hội chúng ta ngày nay, góp phần cải thiện hiệu quả phân bổ nguồn lực, giúp tạo ra các sản phẩm, dịch vụ và công nghệ mới phục vụ con người, thúc đẩy phát triển kinh tế và làm thay đổi xã hội theo hướng tốt đẹp hơn.</p>
                    <p>Hiểu được ý nghĩa to lớn của dữ liệu và vai trò của phân tích dữ liệu, Vietstats và đội ngũ của mình tìm cách khai thác theo cách sáng tạo nhất, tối ưu hóa hệ thống các cơ sở dữ liệu về kinh tế hiện có để cải thiện việc hoạch định các chính sách từ vĩ mô đến vi mô, từ khu vực công đến khu vực tư, từ chính phủ trung ương đến chính quyền địa phương, giúp nâng cao chất lượng công tác hoạch định chính sách và đưa ra các quyết định chính xác, kịp thời và hiệu quả hơn. Dữ liệu không thể được sử dụng theo cách riêng lẻ và máy móc, thiếu hiểu biết về nguồn gốc và độ tin cậy của dữ liệu, vì dữ liệu có chất lượng phải được trải qua quá trình tổng hợp, xử lý, làm sạch và chuyển đổi nghiêm ngặt bởi đội ngũ chuyên gia trong các ngành kết hợp với chuyên gia dữ liệu để được coi là dữ liệu có giá trị.</p>
                    <p>Với đội ngũ chuyên gia phân tích dữ liệu hàng đầu, sự kết hợp giữa trí tuệ thiên tạo (NI) và trí tuệ nhân tạo (AI) cùng năng lực ứng dụng các công cụ phân tích dữ liệu hiện đại, Vietstats đặt mục tiêu trở thành nhà cung cấp dữ liệu kinh tế, nhà phân tích dữ liệu kinh tế và là nhà tư vấn chính sách kinh tế, tài chính và thị trường uy tín, chuyên nghiệp hàng đầu Việt Nam dựa trên tài nguyên dữ liệu lớn về kinh tế của Vietstats.</p>
                </div>
                <br/>
                <div className="page-title">
                    Sứ mệnh và Tầm nhìn   
                </div>
                <div className="p-about_line"></div>

                <div className="p-about_list">
                    <div className="p-about_list_card">
                         <Image  src={mission} alt="tab" loading="lazy"/>
                        <div className="p-about_list_card_title">
                            Sứ mệnh (Mission)
                        </div>
                        <div className="p-about_list_card_content">
                            <p>
                                Để dữ liệu chỉ dẫn chính sách.
                            </p>
                        </div>
                    </div>
                    <div className="p-about_list_card">
                         <Image  src={vision} alt="tab" loading="lazy"/>
                        <div className="p-about_list_card_title">
                        Tầm nhìn (Vision)
                        </div>
                        <div className="p-about_list_card_content">
                            <p>
                            Trở thành doanh nghiệp dẫn đầu Việt Nam trong lĩnh vực cung cấp và khai thác cơ sở dữ liệu kinh tế và tư vấn chiến lược chính sách dựa trên dữ liệu lớn về kinh tế.
                            </p>
                        </div>
                    </div>
                    <div className="p-about_list_card">
                         <Image  src={prise} alt="tab" loading="lazy"/>
                        <div className="p-about_list_card_title">
                        Giá trị cốt lõi (PRISE)
                        </div>
                        <div className="p-about_list_card_content">
                            <p><span><FiCheckCircle/></span> Chuyên nghiệp (Professionalism)</p>
                            <p><span><FiCheckCircle/></span>  Tin cậy (Reliability)</p>
                            <p><span><FiCheckCircle/></span> Chính trực (Integrity)</p>
                            <p><span><FiCheckCircle/></span> Bền vững (Sustainability)</p>
                            <p><span><FiCheckCircle/></span> Hiệu quả (Efficiency)</p> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutModule;
